module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS3.7e3beac0.jpg";